/* global modForm */
/**
 * function to get the saved query string values from the session storage
 * @returns {Object} - query string values
 */
export function getSavedQueryParams() {
	const queryParams = window.sessionStorage ? window.sessionStorage.getItem('queryParams') : null;
	const parsedQueryParams = queryParams ? JSON.parse(queryParams) : null;
	if (parsedQueryParams) {
		modForm.opts.getVars = parsedQueryParams;
	}
	return parsedQueryParams;
}
